import React from 'react'

const debug: boolean = false
// const debug: string = "SelectGenericValueEmpty"

export default function SelectGenericValueEmpty(props: any) {
    let label = props.placeholder

    // check if noValueOption is enabled
    if (!!props.noValueOption) {
        label = props.noValueOptionLabel
    }

    debug && console.log(debug, "render", label, props)

    const classes: string = Classes(props.valueClasses, props.className, {
        'ui5-txt-no-accent-default' : !props.noValueOption || props.noValueOptionNoAccent
    })

    return (
        <React.Fragment>
            <div className={classes} onClick={props.onClick}>
                {props.iconComponent}
                {label}
            </div>
            {props.children}
        </React.Fragment>
    )
}

SelectGenericValueEmpty.defaultProps = {
    valueClasses: "ui5-field-form-editable dropdown-form h-36"
}